export const API_ROOT = process.env.REACT_APP_API_ROOT || '/'
export const USER_WEBSOCKET = process.env.REACT_APP_USER_WEBSOCKET || `/ws/users`
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN ||  'https://6ed0ada713a740869fbb636f8a7d31a7@o482981.ingest.us.sentry.io/5962890'
export const RELEASE = process.env.REACT_APP_RELEASE || '3.0.3'
export const SENTRY_SAMPLE_RATE = process.env.REACT_APP_SENTRY_SAMPLE_RATE|| 1
export const SENTRY_TRACES_SAMPLE_RATE = process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE|| 1
export const SENTRY_DEBUG =  process.env.REACT_APP_SENTRY_DEBUG|| false
export const TITLE = 'Meili Robots'